import { render } from "./ContactInformationEU.vue?vue&type=template&id=679c2b29&scoped=true"
import script from "./ContactInformationEU.vue?vue&type=script&lang=js"
export * from "./ContactInformationEU.vue?vue&type=script&lang=js"

import "./ContactInformationEU.vue?vue&type=style&index=0&id=679c2b29&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-679c2b29"]])

export default __exports__